import { render } from "./Sv052.vue?vue&type=template&id=15c11250&scoped=true"
import script from "./Sv052.vue?vue&type=script&lang=js"
export * from "./Sv052.vue?vue&type=script&lang=js"

import "./Sv052.vue?vue&type=style&index=0&id=15c11250&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c11250"]])

export default __exports__